import Modal1 from "../../DIsplay/Modal/Modal1";
import Button1 from "../../form/Button1";
import approveCashPayment from "../../../controllers/booking/Transactions.js/approveCashPayment";
import { enqueueSnackbar } from "notistack";
import { Modal3 } from "../../DIsplay/Modal/Modal3";
import cancelPayoutRequest from "../../../controllers/settings/wallet/cancelPayoutRequest";

function TransactionsCancelPayoutRequestModal({
  loading,
  setOpen,
  open,
  setLoading,
  callback,
  data,
}) {
  async function handleCancel(ev) {
    ev?.preventDefault();
    setLoading?.(true);
    const res = await cancelPayoutRequest(data?._id)?.finally(() =>
      setLoading?.(false)
    );
    if (res?.return) {
      // console.log({ res });
      enqueueSnackbar(res.msg, { variant: "success" });
      setOpen(false);
      callback?.({
        ...res?.data,
        account: data?.account || res?.data?.account,
      });
    } else enqueueSnackbar(res.msg, { variant: "error" });
  }

  return (
    <Modal3 title="Cancel Reqeust" open={open} setOpen={() => setOpen(false)}>
      <form onSubmit={handleCancel} className="p-6 flex flex-col gap-4">
        <div>Are you sure you want to cancel this reqeust?</div>
        <div className="flex gap-2 items-center">
          <div>
            <Button1
              type="button"
              variant="outlined"
              onClick={() => setOpen(false)}
            >
              Cancel
            </Button1>
          </div>
          <Button1 type="submit" loading={loading}>
            Confirm
          </Button1>
        </div>
      </form>
    </Modal3>
  );
}

export default TransactionsCancelPayoutRequestModal;
